// import React, { Component, Fragment } from 'react'
import React, { Fragment, useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import { v4 as uuid } from 'uuid'
import './App.css'

// import AuthenticatedRoute from './components/shared/AuthenticatedRoute'
import AutoDismissAlert from './components/shared/AutoDismissAlert/AutoDismissAlert'
import Header from './components/shared/Header'
import RequireAuth from './components/shared/RequireAuth'
import Home from './components/Home'
import SignUp from './components/auth/SignUp'
import SignIn from './components/auth/SignIn'
import SignOut from './components/auth/SignOut'
import ChangePassword from './components/auth/ChangePassword'
import ConspiracyShow from './components/conspiracies/ConspiracyShow'
import ConspiracyCreate from './components/conspiracies/ConspiracyCreate'
import ConspiraciesIndex from './components/conspiracies/ConspiraciesIndex'
import ConspiracyForm from './components/shared/ConspiracyForm'

const App = () => {

	const [user, setUser] = useState(null)
	const [msgAlerts, setMsgAlerts] = useState([])

	console.log('user in app', user)
	console.log('message alerts', msgAlerts)

	const clearUser = () => {
		console.log('clear user ran')
		setUser(null)
	}

	const deleteAlert = (id) => {
		setMsgAlerts((prevState) => {
			return (prevState.filter((msg) => msg.id !== id) )
		})
	}

	const msgAlert = ({ heading, message, variant }) => {
		const id = uuid()
		setMsgAlerts(() => {
			return (
				[{ heading, message, variant, id }]
			)
		})
	}

	// Define a style for the divider line
	const dividerStyle = {
		height: '1px',
		backgroundColor: '#dc1f52',
		width: 'calc(100% - 20px)',
		margin: '0 auto'
	}
	
	return (
		<Fragment>
			<Header user={user} />
			<div style={dividerStyle}></div>
			<Routes>
				<Route path='/' element={<Home msgAlert={msgAlert} user={user} />} />
				<Route
					path='/sign-up'
					element={<SignUp msgAlert={msgAlert} setUser={setUser} />}
				/>
				<Route
					path='/sign-in'
					element={<SignIn msgAlert={msgAlert} setUser={setUser} />}
				/>
				<Route
					path='/sign-out'
					element={
						<RequireAuth user={user}>
							<SignOut msgAlert={msgAlert} clearUser={clearUser} user={user} />
						</RequireAuth>
					}
				/>
				<Route
					path='/change-password'
					element={
						<RequireAuth user={user}>
							<ChangePassword msgAlert={msgAlert} user={user} />
						</RequireAuth>
					}
				/>
				<Route
					path='/create-conspiracy'
					element={
						<RequireAuth user={user}>
							<ConspiracyCreate msgAlert={msgAlert} user={user} />
						</RequireAuth>
					}
				/>
				<Route
					path='/create-conspiracy/:storyId'
					element={
						<RequireAuth user={user}>
							<ConspiracyCreate msgAlert={msgAlert} user={user} />
						</RequireAuth>
					}
				/>
				<Route
					path='/conspiracies/:conspiracyId/edit'
					element={
						<RequireAuth user={user}>
							<ConspiracyForm msgAlert={msgAlert} user={user} />
						</RequireAuth>
					}
				/>				
				<Route
					path='/conspiracies/:conspiracyId'
					element={
						<ConspiracyShow msgAlert={msgAlert} user={user} />
					}
				/>	
				<Route
					path='/conspiracies/mine'
					element={
						<ConspiraciesIndex msgAlert={msgAlert} user={user} />
					}
				/>							
			</Routes>
			{msgAlerts.map((msgAlert) => (
				<AutoDismissAlert
					key={msgAlert.id}
					heading={msgAlert.heading}
					variant={msgAlert.variant}
					message={msgAlert.message}
					id={msgAlert.id}
					deleteAlert={deleteAlert}
				/>
			))}
		</Fragment>
	)
}

export default App
